import { faqData } from "./constants";
import { useRef, useState } from "react";
import { CollpaseIconClose, CollpaseIconOpen } from "../../icons/collpaseIcon";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { MOTION_OK, revealTrigger, riseFrom } from "../../utils/animations";

export function FAQSection() {
  const sectionRef = useRef(null);
  const [currentTab, setCurrentTab] = useState("");

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        riseFrom(".faq-head > *", {
          stagger: 0.15,
          scrollTrigger: revealTrigger(".faq-head"),
        });
        riseFrom(".faqs .expandable", {
          y: 40,
          stagger: 0.1,
          scrollTrigger: revealTrigger(".faqs", "top 80%"),
        });
        riseFrom(".faq-cta", {
          scrollTrigger: revealTrigger(".faq-cta", "top 90%"),
        });
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section ref={sectionRef} className="bg-[#010127] relative pt-[96px]">
      <div className="w-[150px] lg:w-[300px] h-[300px] bg-[#0073FF]/50 blur-[120px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[10%] md:translate-y-[-30%]"></div>
      <div className="container flex flex-col gap-[48px] z-50 relative">
        <div className="faq-head space-y-2">
          <h2 className="text-white font-extrabold text-2xl md:text-[32px] text-center">
            Frequently Asked Questions
          </h2>

          <p className="text-[#C0C0C0] text-sm md:text-base text-center">
            Everything you need to know about Analytics Intelligence
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="faqs flex flex-wrap gap-[24px] w-full md:w-[80%] lg:w-[70%] justify-center mx-auto ">
          {faqData.slice(0, 5).map((d) => (
            <div
              className="expandable w-full h-max rounded-xl border border-[#FFFFFF3B] p-3 lg:px-6 lg:py-3"
              key={d.title}
              onClick={() => {
                if (currentTab === d.title) {
                  return setCurrentTab("");
                }
                setCurrentTab(d.title);
              }}
            >
              <div className="expandable-header">
                <p className="!text-[16px] md:!text-[18px] font-bold">
                  {d.title}
                </p>
                {currentTab === d.title ? (
                  <CollpaseIconOpen />
                ) : (
                  <CollpaseIconClose />
                )}
              </div>
              <p
                className={` ${
                  currentTab === d.title ? "expand" : ""
                } expandable-body text-sm md:text-base text-[#C0C0C0]`}
              >
                {d.body}
              </p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="faq-cta text-center">
          <div className="inline-flex items-center text-sm gap-4 bg-[#FFFFFF33] backdrop-blur-sm rounded-full p-3 md:px-6 md:py-3 border border-[#FFFFFF33]">
            <span className="text-blue-200">Can't find your answer?</span>
            <Link to="/faqs">
              <button className="btn-sweep btn-sweep-blue text-white px-6 py-2 rounded-full font-semibold">
                See More
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
